<!-- FullPageObserver.vue -->
<template>
  <div class="indexMain">
    <div class="indexPage indexPage1 videoContainer" style="height: 100vh;">
      <video id="backVideo" autoplay muted loop  playsinline class="background-video">
        <source src="../../static/img/index/backVideo.mp4" type="video/mp4">
      </video>
      <div style="width: 1280px">
        <div id="page0-active0" class="title1 fade-in1" >
          PKPM-CAE通用仿真软件
        </div>
        <div id="page0-active1" class="title2 fade-in2">
          专注于解决工业领域“卡脖子”的通用仿真核心技术难题
        </div>
        <div id="page0-active2" class="buttons fade-in3">
          <div class="button1"
               @click="openUrl('https://product.pkpm.cn/productDetails?type=common&from=common&key=1&productId=2')">
            下载桌面版
          </div>
          <div class="button2" @click="jumpto('cae')">打开WEB版</div>

        </div>
      </div>
    </div>
    <div class="indexPage indexPage2" style="height: 100vh;">
      <div style="width: 1280px">
        <div id="page1-active0" class="fade-in4">
          <div class="title1">
            PRODUCT INTRODUCTION
          </div>
          <div class="title2">
            产品介绍
          </div>
        </div>

        <div style="margin-top: 80px;height: 360px">
          <div  id="page1-active1" class="fade-in5" style="width: 640px;display: inline-block;float: left">
<!--            <img src="../../static/img/index/product.png" alt="" style="width: 100%">-->
            <Carousel autoplay loop :radius-dot='true' :autoplay-speed='4000' dots="outside" :height="338">
              <CarouselItem v-for="item in carouselList">
                <img :src="item.uri" alt="" style="width: 640px;height: 338px">
              </CarouselItem>
            </Carousel>
          </div>
          <div  id="page1-active2" class="fade-in6" style="width:500px;display: inline-block;margin-top: 40px;margin-left: 130px">
            <div class="content">
              PKPM-CAE是一款基于云并拥有完整且自主可控的仿真前后处理系统、任务调度系统、网格划分内核和通用有限元计算内核的通用仿真计算系统。PKPM-CAE的计算功能可覆盖土木领域乃至全工业领域的固体有限元仿真需求，并致力于开发多物理场通用仿真计算系统，满足国内对国产通用仿真计算产品的需求。
            </div>
            <div @click="jump('productIntroduction')" class="button1">
              查看详情
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 135px">
        <img src="../../static/img/index/productBottom.png" alt="">
      </div>
    </div>
    <div class="indexPage indexPage3" style="height: 100vh;">
      <div style="width: 1280px;">
        <div id="page2-active0" class="fade-in7">
          <div class="title1">
            SERVICE AREAS
          </div>
          <div class="title2">
            服务领域
          </div>
        </div>
        <div style="display: flex;justify-content: space-between;margin-top: 80px">
          <div id="page2-active1" class="areas area1 fade-in8">
            <div class="name1">建筑</div>
            <div class="name2">Architecture</div>
          </div>
          <div id="page2-active2" class="areas area2 fade-in9">
            <div class="name1">水电</div>
            <div class="name2">Hydroelectric</div>
          </div>
          <div id="page2-active3" class="areas area3 fade-in10">
            <div class="name1">核电</div>
            <div class="name2">Nuclear power</div>
          </div>
          <div id="page2-active4" class="areas area4 fade-in11">
            <div class="name1">交通</div>
            <div class="name2">Transportation</div>
          </div>
          <div id="page2-active5" class="areas area5 fade-in12">
            <div class="name1">其他</div>
            <div class="name2">Other</div>
          </div>
        </div>
        <div id="page2-active6"  @click="jump('applyCase')" class="button1 fade-in13" style="display: inline-block">
          查看详情
        </div>
      </div>
    </div>
    <div class="indexPage indexPage4" style="height: 100vh;">
      <div style="width: 1280px;">
        <div id="page3-active0" class="fade-in14">
          <div class="title1">
            KNOWLEDGE BASE
          </div>
          <div class="title2">
            知识库
          </div>
        </div>

        <div style="display: flex;justify-content: space-around;margin-top: 100px">
          <div id="page3-active1" class="areas area1 fade-in15">
            <div class="name1">教学视频</div>
            <div class="name2">覆盖多领域有限元分析场景，从基础入门到高阶工程实例逐步演示。通过直观的操作视频，可快速掌握PkpmCAE核心功能，有效应对实际工程中的分析需求。</div>
            <div  @click="jump('videoList')" class="button1">
              查看详情
            </div>
          </div>
          <div id="page3-active2" class="areas area2 fade-in16">
            <div class="name1">技术文档</div>
            <div class="name2">提供PkpmCAE全模块用户手册、操作指南及常见问题解答，涵盖界面详解与多领域实战案例指引。便于随时查阅，高效完成各类有限元分析任务。</div>
            <div  @click="jump('fileList')" class="button1">
              查看详情
            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="indexPage indexPage5" style="height: 100vh;">
      <div style="width: 1280px">
        <div id="page4-active0" style="text-align: center" class="fade-in17">
          <div class="title1">
            ABOUT US
          </div>
          <div class="title2">
            关于我们
          </div>
        </div>
        <div style="margin-top: 60px;display: flex">
          <div id="page4-active1" style="width:624px;display: inline-block;" class="fade-in18">
            <div class="subTitle">北京构力科技有限公司</div>
            <div class="blueBottom"></div>
            <div class="content" style="margin-top: 20px">
              致力于成为建设行业软件与信息化发展的引领者
            </div>
            <div class="content" style="margin-top:8px">
              隶属于中国建筑科学研究院有限公司（以下简称，中国建研院），是我国建筑行业计算机技术开发应用的最早单位之一，前身为中国建研院建筑工程软件研究所。1988年创立了PKPM软件品牌，2017年成立北京构力科技有限公司（以下简称，构力科技），是国资委全国首批十家中央企业员工持股试点单位之一。
            </div>
            <div style="display: flex;justify-content: space-between">
              <div class="contBlock">
                <div>
                  <img src="../../static/img/index/aboutUs1.png" alt="">
                </div>
                <div class="title">
                  企业愿景
                </div>
                <div class="content">
                  致力于成为建设行业软件与信息化发展的引领者
                </div>
              </div>
              <div class="contBlock">
                <div>
                  <img src="../../static/img/index/aboutUs2.png" alt="">
                </div>
                <div class="title">
                  核心价值观
                </div>
                <div class="content">
                  科技创新，引领行业发展；
                  务实共赢，创造客户价值；
                  开拓进取，成就员工梦想。
                </div>
              </div>
              <div class="contBlock">
                <div>
                  <img src="../../static/img/index/aboutUs3.png" alt="">
                </div>
                <div class="title">
                  企业宗旨
                </div>
                <div class="content">
                  以客户为中心、为用户提供优质、高效的软件产品和服务作为自身发展的根本宗旨
                </div>
              </div>

            </div>
            <div  @click="jump('aboutUs')" class="button1">
              查看详情
            </div>
          </div>
          <div id="page4-active2" style="width: 540px;display: inline-block;margin-left: 80px" class="fade-in19">
            <img src="../../static/img/index/aboutUsPic.png" alt="" style="width: 100%">
          </div>

        </div>
      </div>
    </div>
  </div>


</template>

<script>
import {cae_index, getCmsList, sep_cloudDisk} from "../api";
import utils from "../lib/utils";

export default {
  name: 'index',
  data() {
    return {
      nowPage: 0,
      carouselList:[
        // {uri:"../../static/img/index/product/1.png"},
        // {uri:"../../static/img/index/product/2.png"},
        // {uri:"../../static/img/index/product/3.png"},
        // {uri:"../../static/img/index/product/4.png"},
        // {uri:"../../static/img/index/product/5.png"},
        // {uri:"../../static/img/index/product/6.png"},
        // {uri:"../../static/img/index/product/7.png"},
        // {uri:"../../static/img/index/product/8.png"},
        // {uri:"../../static/img/index/product/9.png"},
        // {uri:"../../static/img/index/product/10.png"},
      ],
      isScrolling: false,  // 添加滚动状态标志
      scrollTimeout: null  // 添加定时器引用
    };
  },

  methods: {
    jumpto(target) {
      if (this.$cookies.get("isLogin") === 'true') {
        if (target === 'sep') {
          if (this.$cookies.get("auth") == null || this.$cookies.get("auth").indexOf("sep") === -1) {
            this.$Message.error("您没有权限使用此模块");
            return 0;
          } else {
            // 地址修改
            window.location.href = sep_cloudDisk;
          }
        }
        if (target === 'cae') {
          if (this.$cookies.get("auth") == null || this.$cookies.get("auth").indexOf("cae") === -1) {
            this.$Message.error("您没有权限使用此模块");
            return 0;
          } else {
            // 地址修改
            window.location.href = cae_index;
          }
        }
      } else {
        this.$router.push({
          name: 'login',
          params: {
           intoWeb:true
          }
        })
      }

    },
    openUrl(url) {
      window.open(url)
    },
    jump(target) {
        this.$router.push(target)
    },
    handleScroll(e) {
      e.preventDefault();

      // 如果正在滚动中，直接返回
      if (this.isScrolling) {
        return;
      }

      let targetPages = document.getElementsByClassName('indexPage');
      let targetPage = '';

      if (e.deltaY > 0) {
        // 向下滚动
        if (this.nowPage < targetPages.length - 1) {
          this.nowPage++;
        } else {
          return; // 已经是最后一页
        }
      } else {
        // 向上滚动
        if (this.nowPage > 0) {
          this.nowPage--;
        } else {
          return; // 已经是第一页
        }
      }

      targetPage = targetPages[this.nowPage];

      if (targetPage) {
        // 设置滚动状态
        this.isScrolling = true;

        // 滚动到目标div
        targetPage.scrollIntoView({
          behavior: 'smooth'
        });

        // 600ms后重置滚动状态（根据你的平滑滚动时间调整）
        this.scrollTimeout = setTimeout(() => {
          this.isScrolling = false;
          this.scrollTimeout = null;
        }, 600);
      }
      this.addAnimation()
    },
    handleKeyDown(e) {
      let targetPages = document.getElementsByClassName('indexPage')
      let targetPage = ''
      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (this.nowPage < targetPages.length - 1) {
          this.nowPage++
        }
        targetPage = targetPages[this.nowPage]
        // 滚动到目标div，并让它出现在视图中
        targetPage.scrollIntoView({
          behavior: 'smooth' // 平滑滚动效果
        });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (this.nowPage > 0) {
          this.nowPage--
        }
        targetPage = targetPages[this.nowPage]
        // 滚动到目标div，并让它出现在视图中
        targetPage.scrollIntoView({
          behavior: 'smooth' // 平滑滚动效果
        });
      }
      this.addAnimation()
    },
    addAnimation(){
      console.log(this.nowPage)
      document.getElementById("page0-active0").classList.remove("fade-in1")
      document.getElementById("page0-active1").classList.remove("fade-in2")
      document.getElementById("page0-active2").classList.remove("fade-in3")

      document.getElementById("page1-active0").classList.remove("fade-in4")
      document.getElementById("page1-active1").classList.remove("fade-in5")
      document.getElementById("page1-active2").classList.remove("fade-in6")

      document.getElementById("page2-active0").classList.remove("fade-in7")
      document.getElementById("page2-active1").classList.remove("fade-in8")
      document.getElementById("page2-active2").classList.remove("fade-in9")
      document.getElementById("page2-active3").classList.remove("fade-in10")
      document.getElementById("page2-active4").classList.remove("fade-in11")
      document.getElementById("page2-active5").classList.remove("fade-in12")
      document.getElementById("page2-active6").classList.remove("fade-in13")

      document.getElementById("page3-active0").classList.remove("fade-in14")
      document.getElementById("page3-active1").classList.remove("fade-in15")
      document.getElementById("page3-active2").classList.remove("fade-in16")

      document.getElementById("page4-active0").classList.remove("fade-in17")
      document.getElementById("page4-active1").classList.remove("fade-in18")
      document.getElementById("page4-active2").classList.remove("fade-in19")
      if(this.nowPage===0){
        document.getElementById("page0-active0").classList.add("fade-in1")
        document.getElementById("page0-active1").classList.add("fade-in2")
        document.getElementById("page0-active2").classList.add("fade-in3")
        const video = document.getElementById('backVideo');
        video.currentTime = 0;   // 回到开头
        video.play();           // 开始播放
      }
      if(this.nowPage===1){
        document.getElementById("page1-active0").classList.add("fade-in4")
        document.getElementById("page1-active1").classList.add("fade-in5")
        document.getElementById("page1-active2").classList.add("fade-in6")
      }
      if(this.nowPage===2){
        document.getElementById("page2-active0").classList.add("fade-in7")
        document.getElementById("page2-active1").classList.add("fade-in8")
        document.getElementById("page2-active2").classList.add("fade-in9")
        document.getElementById("page2-active3").classList.add("fade-in10")
        document.getElementById("page2-active4").classList.add("fade-in11")
        document.getElementById("page2-active5").classList.add("fade-in12")
        document.getElementById("page2-active6").classList.add("fade-in13")
      }
      if(this.nowPage===3){
        document.getElementById("page3-active0").classList.add("fade-in14")
        document.getElementById("page3-active1").classList.add("fade-in15")
        document.getElementById("page3-active2").classList.add("fade-in16")
      }
      if(this.nowPage===4){
        document.getElementById("page4-active0").classList.add("fade-in17")
        document.getElementById("page4-active1").classList.add("fade-in18")
        document.getElementById("page4-active2").classList.add("fade-in19")
      }
    },

    getImgList(){
      getCmsList({type:'img',tag:'carousel'}).then((res)=>{
        if(!res.data.result.success){
          this.$Message.error(res.data.result.info);
        }else{
          this.carouselList=res.data.result.cmsFiles
          if(this.carouselList.length!==0){
            this.carouselList.forEach((item)=>{
              item.uri= utils.handleHttps(item.uri)
            })
          }
        }
      }).catch((error)=> {
        console.log(error);
      });
    },

  },


  mounted() {

    this.addAnimation()
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 0)
    window.addEventListener('wheel', this.handleScroll, {passive: false});
    window.addEventListener('keydown', this.handleKeyDown);

    this.getImgList()

    //自动轮播
    // setInterval(() => {
    //   let targetPages = document.getElementsByClassName('indexPage')
    //   let targetPage = ''
    //   this.nowPage++;
    //   if(this.nowPage===targetPages.length-1){
    //     this.nowPage=0
    //   }
    //   targetPage = targetPages[this.nowPage]
    //   targetPage.scrollIntoView({
    //     behavior: 'smooth' // 平滑滚动效果
    //   });
    // }, 3000);
  },
  beforeDestroy() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    document.body.style.overflow = '';
    window.removeEventListener('wheel', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
  }


};
</script>

<style scoped lang="scss">
.button1:hover{
  background: #267FE4!important;
}
.button2:hover{
  background: #EFEFEF!important;
  color: #0E71E2!important;
}
.indexPage4 .button1:hover{
  background: #EFEFEF!important;
  color: #0E71E2!important;
}
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;      /* 全屏高度，根据需要调整 */
  overflow: hidden;
}

.background-video {
  position: absolute;
  //top: 50%;
  //left: 50%;
  //transform: translate(-50%, -50%);
  //min-width: 100%;
  //min-height: 100%;
  height: 100%;
  width: 100%;
  //height: auto;
  //width: auto;
  object-fit: cover;  /* 保持宽高比，覆盖容器 */
  z-index: 0;
}

.indexPage1 {
  //background: url("../../static/img/index/indexPage1Back.png") no-repeat;
  //background: url("../../static/img/index/backVideo.mp4") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;

  .title1 {
    font-weight: 600;
    font-size: 56px;
    color: #FFFFFF;
    margin-top: 306px;
  }

  .title2 {
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    margin-top: 32px;
  }

  .buttons {
    margin-top: 80px;

    div {
      display: inline-block;
      width: 240px;
      height: 60px;
      cursor: pointer;
    }

    .button1 {
      text-align: center;
      line-height: 60px;
      background: #0069E0;
      border-radius: 2px;
      font-weight: 600;
      font-size: 20px;
      color: #FFFFFF;
    }

    .button2 {
      margin-left: 40px;
      text-align: center;
      line-height: 60px;
      border-radius: 2px;
      font-weight: 600;
      font-size: 20px;
      color: #FFFFFF;
      border: 1px solid #FFFFFF;
    }
  }
}
.indexPage2 {
  display: flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
  overflow-x: hidden;

  .title1 {
    font-weight: bold;
    font-size: 66px;
    color: #D7D7D7;
    margin-top: 100px;
  }

  .title2 {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    margin-top: -56px;
  }

  .content {
    text-align: left;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 32px;
  }

  .button1 {
    margin-top: 40px;
    width: 160px;
    height: 44px;
    background: #0069E0;
    border-radius: 2px;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 44px;
    cursor: pointer;
  }
}
.indexPage3 {
  background: url("../../static/img/index/indexPage3Back.png") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;

  .title1 {
    font-weight: bold;
    font-size: 66px;
    color: #D7D7D7;
    margin-top: 100px;
  }

  .title2 {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    margin-top: -56px;
  }

  .areas {
    width: 240px;
    height: 420px;

    .name1 {
      margin-top: 315px;
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
    }

    .name2 {
      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
    }
  }

  .area1 {
    background: url("../../static/img/index/service1.png");
  }

  .area2 {
    background: url("../../static/img/index/service2.png");
  }

  .area3 {
    background: url("../../static/img/index/service3.png");
  }

  .area4 {
    background: url("../../static/img/index/service4.png");
  }

  .area5 {
    background: url("../../static/img/index/service5.png");
  }

  .button1 {
    margin-top: 70px;
    width: 160px;
    height: 44px;
    background: #0069E0;
    border-radius: 2px;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 44px;
    cursor: pointer;
  }
}
.indexPage4 {
  background: url("../../static/img/index/indexPage4Back.png") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;

  .title1 {
    font-weight: bold;
    font-size: 66px;
    color: rgba(255,255,255,0.16);
    margin-top: 100px;
  }

  .title2 {
    font-weight: 600;
    font-size: 40px;
    color: #FFFFFF;
    margin-top: -56px;
  }

  .areas {
    width: 560px;
    height: 340px;
    padding: 50px;
    text-align: left;
    .name1 {
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
    }

    .name2 {
      height: 110px;
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      width: 220px;
    }
    .button1 {
      text-align: center;
      margin-top: 40px;
      width: 160px;
      height: 44px;
      border: 1px solid #FFFFFF;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 44px;
      cursor: pointer;
    }
  }

  .area1 {
    background: url("../../static/img/index/knowledge2.png");
  }

  .area2 {
    background: url("../../static/img/index/knowledge1.png");
  }



}
.indexPage5 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  overflow-x: hidden;

  .title1 {
    font-weight: bold;
    font-size: 66px;
    color: #D7D7D7;
    margin-top: 100px;
  }

  .title2 {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    margin-top: -56px;
  }
  .subTitle{
    font-weight: 600;
    font-size: 24px;
    color: #333333;
  }
  .blueBottom{
    width: 240px;
    height: 13px;
    background: #0069E0;
    margin-top: -13px;
  }

  .content {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .contBlock{
    margin-top: 60px;
    width: 168px;
    .title{
      margin-top: 20px;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
    }
    .content{
      margin-top: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }

  }
  .button1 {
    text-align: center;
    margin-top: 60px;
    width: 160px;
    height: 44px;
    background: #0069E0;
    border-radius: 2px;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 44px;
    cursor: pointer;
  }
}

.fade-in1{
  opacity: 0;
  animation: fadeIn 2s forwards;
}
.fade-in2{
  opacity: 0;
  animation: fadeIn 4s forwards;
}
.fade-in3{
  opacity: 0;
  animation: fadeIn 6s forwards;
}
.fade-in4{
  opacity: 0;
  animation: fadeIn 2s forwards;
}
.fade-in5{
  opacity: 0;
  left: 50px;
  animation: fadeInLeft 2s forwards;
}
.fade-in6{
  opacity: 0;
  left: 50px;
  animation: fadeInRight 2s forwards;
}
.fade-in7{
  opacity: 0;
  animation: fadeIn 2s forwards;
}
.fade-in8{
  opacity: 0;
  animation: fadeInUp 1s forwards;
}
.fade-in9{
  opacity: 0;
  animation: fadeInUp 1.5s forwards;
}
.fade-in10{
  opacity: 0;
  animation: fadeInUp 2s forwards;
}
.fade-in11{
  opacity: 0;
  animation: fadeInUp 2.5s forwards;
}
.fade-in12{
  opacity: 0;
  animation: fadeInUp 3s forwards;
}
.fade-in13{
  opacity: 0;
  animation: fadeInUp 3.5s forwards;
}
.fade-in14{
  opacity: 0;
  animation: fadeIn 2s forwards;
}
.fade-in15{
  opacity: 0;
  animation: fadeInLeft 2s forwards;
}
.fade-in16{
  opacity: 0;
  animation: fadeInRight 2s forwards;
}
.fade-in17{
  opacity: 0;
  animation: fadeIn 2s forwards;
}
.fade-in18{
  opacity: 0;
  animation: fadeInLeft 2s forwards;
}
.fade-in19{
  opacity: 0;
  animation: fadeInRight 2s forwards;
}
@keyframes fadeIn {
  from { opacity: 0;transform: translateY(30%)}
  to { opacity: 1; transform: translateY(0)}
}
@keyframes fadeInLeft {
  from { opacity: 0; transform: translate(-100%,-30%);}
  to { opacity: 1;  transform: translate(0,0);}
}
@keyframes fadeInRight {
  from { opacity: 0;transform: translate(100%,-30%)}
  to { opacity: 1; transform: translate(0,0)}
}
@keyframes fadeInUp {
  from { opacity: 0;transform: translateY(100%)}
  to { opacity: 1; transform: translateX(0)}
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue